import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ReadState } from "source/app/services/UI/State/ReadState";
import * as toastr from "toastr";

export function ExportLink() {
    return (
        <IconWithText
            id="bookOfMindExportLink"
            iconSuffix={EGlyphicon["arrow-up"]}
            whenClicked={() => {
                const bookOfMindState = ReadState<IBookOfMindState>(
                    ESharedFunction.BookOfMind
                )!;

                if (bookOfMindState.chronologicalQuotes.length !==
                    bookOfMindState.remainingQuotesToDisplay.length) {
                    throw new Error(
                        "Run this function on the first page of book of mind quotes"
                    );
                }

                const allQuotesAsString = bookOfMindState.remainingQuotesToDisplay
                    ?.map((quote) => quote.quote)
                    .join("\n\n");

                DownloadTextFile(
                    allQuotesAsString,
                    GetBookOfMindExportFileName(
                        bookOfMindState.chronologicalQuotes.length
                    )
                );

                toastr.info(`Quotes exported to text file`);
            }}
            displayAsBlock={false}
        >
            Export
        </IconWithText>
    );
}

export function DownloadTextFile(text: string, fileName: string) {
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

export function GetBookOfMindExportFileName(totalCount: number) {
    return `book_of_mind_${totalCount}.txt`;
}
